<template>
	<div>
		<div class="empty-img" v-if="data.length==0">
      <img src="./study.png"/>
      <p>无最近学习</p>
    </div>
		<div class="me-history">
			<ul class="me-history-items f-cbli" v-dt-infinite-scroll="getData">
				<!-- <li class="me-history-item me-history-item-2">
					<div class="me-history-pic f-img-box">
						<img src="../index/lesson-pic.png">
					</div>
					<div class="me-history-content">
						<div class="me-history-title o1">JavaScript忍者秘籍</div>
						<div class="me-history-info f-cb">
							<div class="me-history-rate">已学56%</div>
							<div class="me-history-note">笔记 3</div>
							<div class="me-history-answer">回答 1</div>
						</div>
						<div class="me-history-link">
							<div class="me-history-link-1">继续学习>></div>
							<div class="me-history-link-2">复习一下>></div>
						</div>
					</div>
				</li> -->
				<li class="me-history-item me-history-item-1" v-for="(item,index) in data">
					<div class="me-history-pic f-img-box">
						<img :src="item.cover_img">
					</div>
					<div class="me-history-content">
						<div class="me-history-title o1" v-text="item.course_title"></div>
						<div class="me-history-info f-cb">
							<div class="me-history-rate">已学{{item.schedule}}</div>
							<div class="me-history-note">笔记 {{item.noteNum}}</div>
							<div class="me-history-answer">回答 {{item.answerNum}}</div>
						</div>
						<div class="me-history-link">
							<div class="me-history-link-1" v-if="getStatus(item)==1" @click="to('/lesson-chapter/'+item.id+'/'+item.section_id)">继续学习>></div>
							<div class="me-history-link-1" v-else-if="getStatus(item)==2" @click="to('/lesson-chapter/'+item.id+'/'+item.section_id)">开始学习>></div>
							<div class="me-history-link-2" v-else-if="getStatus(item)==3"  @click="to('/lesson-detail/'+item.id)">查看课程>></div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			to(name){
				this.$router.push(name);
			},
			getData(page){
			  var length=10;
			  return new Promise((resolve,reject)=>{
          this.$api.get("",{
            api:"/v1/my/myCourse",
            user_type:this.tools.getStorage("user_type"),
            page,
            len: length
          },res => {
            var data=res.data;
            this.data=this.data.concat(data);
            if(data.length<length){
              reject();
            }
            else{
              resolve();
            }
          })
        })
			},
			getStatus(item){
				var isEnroll=item.is_baoming,
					open_status=item.open_status,
					stime=item.start_time,
					etime=item.end_time,
					course_id=item.course_id,
					schedule=item.schedule
				//isEnroll 0未报名 1报名
				//return 3查看课程 1继续学习 2开始学习
				//open_status 0不开放 1限时开放 2开放
				var nowTimestamp=new Date().getTime()/1000;
				if(open_status == 0 || isEnroll == 0){//如果课程不开放或是没报名
					return 3
				}
				else if(open_status == 1){//限时开放的课程 查看时效
					if(nowTimestamp > stime && nowTimestamp < etime){
						if(schedule == '0%'){//进度为0
							return 2;
						}
						else{
							return 1
						}

					}
					else{
						return 3;
					}
				}
				else if(open_status == 2){//开放课程
					if(schedule == '0%'){
						return 2
					}
					else{
						return 1
					}
				}
			}
		}
	}
</script>

<style>
	.me-history-items{
		padding-top:0.133rem;
	}
	.me-history-item{
		margin:0.4rem 0.4rem 0 0.4rem;
	}
	.me-history-pic{
		float:left;
		overflow: hidden;
		width:2.88rem;
		height:2.106rem;
		border-radius: 0.133rem;
	}
	.me-history-content{
		float:right;
		width:6.133rem;
	}
	.me-history-title{
		margin-top:0.133rem;
		font-size: 0.426rem;
		color:#333;
	}
	.me-history-info{
		margin-top:0.266rem;
		font-size: 0.346rem;
		line-height: 0.346rem;
		color:#999;
	}
	.me-history-rate{
		float:left;
		width:2.373rem;
	}
	.me-history-note{
		float:left;
		width:1.973rem;
	}
	.me-history-answer{
		float:left;
	}
	.me-history-link{
		margin-top:0.453rem;
		font-size: 0.426rem;
		line-height: 0.426rem;
	}
	/* .me-history-link-1,
	.me-history-link-2{
		display: none;
	} */
	.me-history-link-1{
		color:#EC6D3A;
	}
	.me-history-link-2{
		color:#3192E0;
	}
	/* .me-history-item-1 .me-history-link-1{
		display: block;
	}
	.me-history-item-2 .me-history-link-2{
		display: block;
	} */
</style>



// WEBPACK FOOTER //
// src/components/me-history/me-history.vue